import { createSlice } from "@reduxjs/toolkit";
import {
  addCompanyDetails,
  addJobPostByHireTalent,
  fetchHireTalentProfile,
  getJobPostData,
  hireTalentSignUp,
  updateHireTalentSection2,
  updateHireTalentSection3,
  updateHireTalentSection4,
  updateHireTalentProfileStep,
} from "../actions/authAction";

const initialState = {
  isLoading: false,
  subLoading: false,
  isHireTalentModal: false,
  pagename: "signup",
  startStep: 1,
  jobPostList: {},
  JobHeader: [
    "S.No.",
    "Job Title",
    "Category",
    "Status",
    "Applicant",
    "Location",
    "Action"
  ],
};

const hireTalentSlice = createSlice({
  name: "hire-talent",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.pagename = action.payload;
    },
    setIsHireTalentModal: (state, action) => {
      state.isHireTalentModal = action.payload;
    },
    setStartStep: (state, action) => {
      state.startStep = action.payload;
    },
  },
  extraReducers: (builder) => {
    // hire-talent-sign-up
    builder.addCase(hireTalentSignUp.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(hireTalentSignUp.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(hireTalentSignUp.rejected, (state, action) => {
      state.subLoading = false;
    });
    // add-company-details
    builder.addCase(addCompanyDetails.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(addCompanyDetails.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(addCompanyDetails.rejected, (state, action) => {
      state.subLoading = false;
    });

    // update-section-2
    builder.addCase(updateHireTalentSection2.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentSection2.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentSection2.rejected, (state) => {
      state.subLoading = false;
    });

    // update-section-3
    builder.addCase(updateHireTalentSection3.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentSection3.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentSection3.rejected, (state) => {
      state.subLoading = false;
    });

    // update-section-4
    builder.addCase(updateHireTalentSection4.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentSection4.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentSection4.rejected, (state) => {
      state.subLoading = false;
    });

    // fetch profile
    builder.addCase(fetchHireTalentProfile.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(fetchHireTalentProfile.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(fetchHireTalentProfile.rejected, (state) => {
      state.subLoading = false;
    });

    // update profile
    builder.addCase(updateHireTalentProfileStep.pending, (state) => {
      state.subLoading = true;
    });
    builder.addCase(updateHireTalentProfileStep.fulfilled, (state) => {
      state.subLoading = false;
    });
    builder.addCase(updateHireTalentProfileStep.rejected, (state) => {
      state.subLoading = false;
    });

    // addJobPostByHireTalent
    builder.addCase(addJobPostByHireTalent.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(addJobPostByHireTalent.fulfilled, (state, action) => {
      state.subLoading = false;
    });
    builder.addCase(addJobPostByHireTalent.rejected, (state, action) => {
      state.subLoading = false;
    });

    // getJobPostData
    builder.addCase(getJobPostData.pending, (state, action) => {
      state.subLoading = true;
    });
    builder.addCase(getJobPostData.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      // state.jobPostList = data || [];
      state.subLoading = false;
      const grouped = Object?.groupBy(data||[], (p) => p?.status);
      state.jobPostList = {
        all: data,
        ...grouped,
      };
    });
    builder.addCase(getJobPostData.rejected, (state, action) => {
      state.subLoading = false;
    });
  },
});

export default hireTalentSlice.reducer;
export const { setPage, setIsHireTalentModal, setStartStep } = hireTalentSlice.actions;
